import dayjs from 'dayjs';

import { DEFAULT_DATE_FORMAT, FormatDateProps } from '@xemplo/date-time';

export const formatDate = ({ value, format = DEFAULT_DATE_FORMAT }: FormatDateProps) => {
  if (!value) return 'N/A';
  return dayjs(value).format(format);
};
